/** Access-token expiry is recoverable; rejected identity/session claims are not. */
export function authErrorCode(body: unknown): string | undefined {
  if (!body || typeof body !== "object") return undefined;
  const response = body as { code?: unknown; error?: { code?: unknown } };
  const code = response.code ?? response.error?.code;
  return typeof code === "string" ? code : undefined;
}

export function canRefreshAuthentication(body: unknown): boolean {
  const code = authErrorCode(body);
  // Permit one recovery for legacy servers without a structured error code.
  return !code || code === "AUTH_TOKEN_EXPIRED" || code === "TOKEN_EXPIRED";
}
